
export default {
	computed: {
		placeholder() {
			return (
				((this.$store.getters["navigation/isUnscramblerResultsPage"] ||
					this.$store.getters[
						"navigation/isScrabbleDictionaryResultsPage"
					] ||
					this.$store.getters["navigation/isAnagramResultsPage"]) &&
					this.$route.params?.tiles) ||
				"ENTER LETTERS"
			);
		},
		tilesFontsize() {
			const smallerLettersThreshold = 15;
			const queryLength = this.placeholder.length;
			const fontSize = queryLength >= smallerLettersThreshold ? 22 : 25;
			if (queryLength >= smallerLettersThreshold) {
				return `${
					fontSize - (queryLength - smallerLettersThreshold)
				}px`;
			}
			return null;
		},
	},
	methods: {
		onClick() {
			this.$emit("click");
		},
	},
};
